import { useQueries, UseQueryResult } from '@tanstack/react-query';
import { ImagePair } from '../../models/PlaceService.ts';
import { useMemo } from 'react';
import { getFuelingServiceImage } from '../../api/fueling-service.ts';

export default function useFuelingServiceImages(
  serviceId: string,
  imageIds: string[],
  options?: { enabled?: boolean },
): UseQueryResult<ImagePair, Error>[] {
  const queries = useMemo(() => {
    if (!serviceId || !imageIds) return [];

    return imageIds.map((imageId) => ({
      queryKey: ['fuelingServices', serviceId, 'images', imageId] as const,
      queryFn: async () => {
        const res = await getFuelingServiceImage({ serviceId, imageId });
        const returnPair: ImagePair = {
          imageId: imageId,
          signedUrl: res?.signedUrl ?? '',
        };
        return returnPair || null;
      },
      enabled: !!serviceId && !!imageId && (options?.enabled ?? true),
    }));
  }, [serviceId, imageIds, options?.enabled]);

  return useQueries({
    queries,
  }) as UseQueryResult<ImagePair, Error>[];
}
